import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { MailingListItem } from '@/models'

export type { MailingListItem }

interface GetMailingListRequest {
  buildingId: number
}

export const getMailingListQueryKey = (data: GetMailingListRequest) => ['useGetMailingList', data]

export const getMailingList = async ({ buildingId }: GetMailingListRequest) => {
  const { data } = await authAPI.get<MailingListItem[]>(`/mailinglist/building/${buildingId}`)
  return data
}

export const useGetMailingList = (
  data: GetMailingListRequest,
  options?: Omit<UseQueryOptions<MailingListItem[]>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery({
    ...options,
    enabled: !!data.buildingId && (options?.enabled ?? true),
    queryFn: () => getMailingList(data),
    queryKey: getMailingListQueryKey(data),
  })
}
